import { render, staticRenderFns } from "./ProfileVitalSignBodyMassCard.vue?vue&type=template&id=27ff2b39&"
import script from "./ProfileVitalSignBodyMassCard.vue?vue&type=script&lang=js&"
export * from "./ProfileVitalSignBodyMassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports